/* PaginatedAppGrid.styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _9 = "._19pkap9k{margin-top:var(--ds-space-800)}";
const _8 = "._i0dlf1ug{flex-basis:0%}";
const _7 = "._1o9zkb7n{flex-shrink:1}";
const _6 = "._16jlkb7n{flex-grow:1}";
const _5 = "._19pka5zd{margin-top:var(--ds-space-600)}";
const _4 = "._1bah1h6o{justify-content:center}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
export const GridFooterContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  GridFooterContainer.displayName = 'GridFooterContainer';
}
export const ButtonContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pka5zd", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ButtonContainer.displayName = 'ButtonContainer';
}
export const InitialFetchErrorContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _3, _4, _6, _7, _8]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  InitialFetchErrorContainer.displayName = 'InitialFetchErrorContainer';
}
export const ErrorContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_9]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkap9k", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ErrorContainer.displayName = 'ErrorContainer';
}